export default {
  FETCHING: 'fetching',
  FAILED: 'failed',
  SAVE: 'save'
}
